import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import EarnMessage from './EarnMessage';

const EarnStatusMessages = ({ me }) => {
  const { t } = useTranslation();

  if (!me || (me && me.advertise_enable) || (me && me.advertise_blocked) || (me && ['no', 'accepted'].indexOf(me.advertise_status) >= 0)) {
    return null;
  }

  const renderMessageStatus = () => {
    switch(me.advertise_status) {
      case 'in_review':
        return (
          <EarnMessage type="in_review">
            {t("We are reviewing your account and automatically turn on advertising")}<br />
            {t("if it meets all of our advertising guidelines.")}
          </EarnMessage>
        );
      case 'declined':
        return (
          <EarnMessage type="declined">
            {t("We reviewed your account and it doesn’t meet one or more")}<br />
            {t("of our advertising guidelines.")}
          </EarnMessage>
        );
      default:
        return null;
    }
  };

  return (
    <div className="earn-status-messages__component">
      {renderMessageStatus()}
    </div>
  );
};

EarnStatusMessages.propTypes = {
  me: PropTypes.object,
};
EarnStatusMessages.defaultProps = {
  me: null,
};

const mapStateToProps = state => ({
  me: state.usersReducer.me,
});

export default connect(
  mapStateToProps,
)(EarnStatusMessages);
